export default function InputLabel({
  label,
  htmlFor,
}: {
  label: string;
  htmlFor?: string;
}) {
  return (
    <label htmlFor={htmlFor} className="label-typo text-black-typo pb-2 ">
      {label}
    </label>
  );
}
